// extracted by mini-css-extract-plugin
export default {"container":"SubLayout_container__7a8Jk"};